import { render, staticRenderFns } from "./pigSign.vue?vue&type=template&id=7f5a23a8&scoped=true&"
import script from "./pigSign.vue?vue&type=script&lang=js&"
export * from "./pigSign.vue?vue&type=script&lang=js&"
import style0 from "./pigSign.vue?vue&type=style&index=0&id=7f5a23a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a23a8",
  null
  
)

export default component.exports